import React, { Fragment } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { FormControl, InputLabel, Select, MenuItem, FormHelperText, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    formControl: {
        marginTop: '1.2rem',
    },
    root: {
        '& legend:focus': {
            width: '2rem',
        }
    },
}));

const SelectComp = ({ error, label, name, className, helperText, children, options, formProps, ...rest }) => {
    const classes = useStyles();
    return (
        <FormControl className={classes.formControl} error={error} {...formProps}>
            <InputLabel htmlFor={name}>{label}</InputLabel>
            <Select
                label={label}
                name={name}
                className={clsx(classes.root, className)}
                {...rest}
            >
                {children}
                {Array.isArray(options) && options.length && (<MenuItem value="">Select {label}</MenuItem>)}
                {Array.isArray(options) && options.length && (
                    React.Children.toArray(options.map((option, index) => <MenuItem value={option.value}>{option.label}</MenuItem>))
                )}
            </Select>
            {error && <FormHelperText variant="outlined">{helperText}</FormHelperText>}
        </FormControl>
    );
};

SelectComp.propTypes = {
    label: PropTypes.string.isRequired,
    className: PropTypes.string,
    children: PropTypes.any.isRequired,
    helperText: PropTypes.string,
    formProps: PropTypes.object,
};

SelectComp.defaultProps = {
    label: PropTypes.string.isRequired,
    className: "",
    children: PropTypes.any.isRequired,
    helperText: "",
    formProps: {},
};

export default SelectComp;